import { useState, useCallback, useMemo } from 'react';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { useGetVorQuery } from '../../../../api/endpoints/technicalSupportRequest';

const useVorData = (dealerId) => {
  const { getCurrentLanguageId } = useLanguage();

  const [pagination, setPagination] = useState({
    pageNumber: 1,
    pageSize: 10
  });

  const queryArgs = useMemo(() => {
    const args = {
      activeOnly: 1,
      pageNumber: pagination.pageNumber,
      pageSize: pagination.pageSize,
      languageId: getCurrentLanguageId()
    };

    if (dealerId !== null && dealerId !== undefined && dealerId !== '') {
      args.dealerId = dealerId;
    }

    return args;
  }, [pagination.pageNumber, pagination.pageSize, dealerId, getCurrentLanguageId]);

  const { data: response, isLoading, refetch, error } = useGetVorQuery(queryArgs);

  const requests = response?.items || [];
  const totalCount = response?.totalCount || 0;

  const onPageChange = useCallback((eOrPagination) => {
    if (eOrPagination && typeof eOrPagination === 'object' && 'page' in eOrPagination) {
      setPagination({
        pageNumber: (eOrPagination.page ?? 0) + 1,
        pageSize: eOrPagination.rows ?? 10
      });
      return;
    }

    if (eOrPagination && typeof eOrPagination === 'object' && 'pageNumber' in eOrPagination) {
      setPagination({
        pageNumber: eOrPagination.pageNumber ?? 1,
        pageSize: eOrPagination.pageSize ?? 10
      });
    }
  }, []);

  return {
    requests,
    loading: isLoading,
    totalCount,
    pagination,
    onPageChange,
    refetch,
    error
  };
};

export default useVorData;
